module.exports = __webpack_public_path__ + "static/img/produce04.d2729ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/module/technology/images/produce04.png
// module id = 134
// module chunks = 4